import React, { useMemo, useState } from 'react'
import moment from 'moment'
import PropTypes, { object, string } from 'prop-types'
import { useTranslation } from 'react-i18next'

import { ClockIcon, CTRIcon } from 'images'

import Fade from 'components/Shared/Wrappers/Fade'
import CustomerIds from 'components/PackageBuilder/CreateSteps/CustomerSegmentation/CustomerList/CustomerIds'
import { CustomerSegmentationContext } from 'components/PackageBuilder/CreateSteps/CustomerSegmentation/CustomerSegmentationContext'
import { remoteSettingsToState } from 'components/PackageBuilder/CreateSteps/CustomerSegmentation/customerSegmentation'
import EventsAccordion from '../shared/EventsAccordion'
import CustomerSegmentationInfo from './elements/CustomerSegmentationInfo'
import InfoItem from '../shared/InfoItem'


export default function BuildResults({
  selectedEvents,
  targetMode,
  remoteCustomerSegmentation,
}) {
  const { t } = useTranslation()
  const [customerModalOpen, setCustomerModalOpen] = useState(false)
  
  const displayTargetMode = () => {
    if (targetMode === 'selective_mode') return t('PackageBuilder.modes.selectiveMode')

    if (targetMode === 'inclusive_mode') return t('PackageBuilder.modes.inclusiveMode')
    return ''
  }

  const customerSegmentation = useMemo(() => {
    return remoteSettingsToState(remoteCustomerSegmentation)
  }, [remoteCustomerSegmentation])

  // return
  return (
    <Fade transitionDuration={1000} delay={0}>
      <div data-cy="third-step-screen">
        <EventsAccordion
          header={
            <p className="events-title">
              {t('PackageBuilder.packageBuilderResults.events')}
            </p>
          }
          body={
            <div className="d-flex flex-column p-0 gap-2">
              {selectedEvents && selectedEvents.length > 0
                ? selectedEvents.map((event) => {
                  return (
                    <div
                      key={event.id}
                      className='event-item'
                    >
                      <p className="title">{event.title}</p>

                      <div className="date">
                        <ClockIcon height={12} width={17} />

                        <time>
                          {moment.utc(event.start_date_time).format('DD.MM.YYYY HH:mm')}
                        </time>
                      </div>
                    </div>
                  )
                })
                : null}
            </div>
          }
        />

        <div className="advanced-settings-info">
          <InfoItem info={{ 
            title: t('PackageBuilder.targetMode'), 
            value: displayTargetMode(),
            icon: <CTRIcon width={22} height={22}/>,
          }} />

          {customerSegmentation && (
            <CustomerSegmentationContext.Provider value={customerSegmentation}>
              <CustomerSegmentationInfo setCustomerModalOpen={setCustomerModalOpen} />
                      
              <CustomerIds open={customerModalOpen} setOpen={setCustomerModalOpen} readOnly />
            </CustomerSegmentationContext.Provider>
          )}
        </div>
      </div>
    </Fade>
  )
}

BuildResults.propTypes = {
  selectedEvents: PropTypes.arrayOf(object),
  isMerged: PropTypes.bool,
  mergedPackages: PropTypes.arrayOf(string),
  targetMode: PropTypes.string,
  remoteCustomerSegmentation: PropTypes.object,
}
